define("settings/components/modal/form-input", ["exports", "@ember/component", "@ember/object", "@ember/runloop", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _object, _runloop, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/runloop",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#let (uuid) as |uniqueId|}}
  
    <div class={{concat-classes (if @wrapperClass @wrapperClass "o--formWrapper") "has--error"}}>
  
      {{#if @label}}
        <label class={{@qaClassInputLabel}} for={{uniqueId}}>
          {{@label}}
        </label>
      {{/if}}
  
      {{#if (has-block)}}
        {{yield uniqueId}}
      {{else}}
        <Input
          @type={{if @type @type "text"}}
          @value={{@value}}
          autocomplete={{@autocomplete}}
          class="o--form__input {{if @disabled 'u--mute'}} {{@qaClass}}"
          disabled={{@disabled}}
          id={{uniqueId}}
          placeholder={{if @placeholder @placeholder @label}}
          required={{if @required @required true}}
          {{did-insert this.focusInput}}
          {{on "input" (optional @handleInput)}}
        />
        {{#if @validationErrors}}
          <div class="u--m__t__xs">
            <span class="cPM--field__helperText--danger">
              {{@validationErrors}}
            </span>
          </div>
        {{/if}}
      {{/if}}
    </div>
  {{/let}}
  */
  {
    "id": "Wbqoj/8r",
    "block": "[[[44,[[28,[37,1],null,null]],[[[1,\"\\n  \"],[10,0],[15,0,[28,[37,2],[[52,[30,2],[30,2],\"o--formWrapper\"],\"has--error\"],null]],[12],[1,\"\\n\\n\"],[41,[30,3],[[[1,\"      \"],[10,\"label\"],[15,0,[30,4]],[15,\"for\",[30,1]],[12],[1,\"\\n        \"],[1,[30,3]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[48,[30,14]],[[[1,\"      \"],[18,14,[[30,1]]],[1,\"\\n\"]],[]],[[[1,\"      \"],[8,[39,6],[[16,\"autocomplete\",[30,5]],[16,0,[29,[\"o--form__input \",[52,[30,6],\"u--mute\"],\" \",[30,7]]]],[16,\"disabled\",[30,6]],[16,1,[30,1]],[16,\"placeholder\",[52,[30,8],[30,8],[30,3]]],[16,\"required\",[52,[30,9],[30,9],true]],[4,[38,7],[[30,0,[\"focusInput\"]]],null],[4,[38,8],[\"input\",[28,[37,9],[[30,12]],null]],null]],[[\"@type\",\"@value\"],[[52,[30,10],[30,10],\"text\"],[30,11]]],null],[1,\"\\n\"],[41,[30,13],[[[1,\"        \"],[10,0],[14,0,\"u--m__t__xs\"],[12],[1,\"\\n          \"],[10,1],[14,0,\"cPM--field__helperText--danger\"],[12],[1,\"\\n            \"],[1,[30,13]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null]],[]]],[1,\"  \"],[13],[1,\"\\n\"]],[1]]]],[\"uniqueId\",\"@wrapperClass\",\"@label\",\"@qaClassInputLabel\",\"@autocomplete\",\"@disabled\",\"@qaClass\",\"@placeholder\",\"@required\",\"@type\",\"@value\",\"@handleInput\",\"@validationErrors\",\"&default\"],false,[\"let\",\"uuid\",\"concat-classes\",\"if\",\"has-block\",\"yield\",\"input\",\"did-insert\",\"on\",\"optional\"]]",
    "moduleName": "settings/components/modal/form-input.hbs",
    "isStrictMode": false
  });
  let FormInputComponent = _exports.default = (_class = class FormInputComponent extends _component2.default {
    focusInput(element) {
      if (this.args.autofocus) {
        (0, _runloop.scheduleOnce)('afterRender', this, this._focusInput, element);
      }
    }
    _focusInput(input) {
      input.focus();
    }
  }, (_applyDecoratedDescriptor(_class.prototype, "focusInput", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "focusInput"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, FormInputComponent);
});